import {RSDispatcherEvent} from './dispatcher-event';


export class RSDispatcher
{
	/**
	 *
	 */
	constructor()
	{
		this.events = {};
	}


	/**
	 * @param {string} eventName
	 * @param {?Object} data
	 */
	dispatch(eventName, data = null)
	{
		const event = this.events[eventName];

		if (event)
		{
			let baseData = {
				'name': eventName
			};

			if(data != null) event.fire({...baseData, ...data});
			else event.fire(baseData);
		}
	}


	/**
	 * @param {string} eventName
	 * @param {function} callback
	 */
	on(eventName, callback)
	{
		let event = this.events[eventName];

		if (!event)
		{
			event = new RSDispatcherEvent(eventName);

			this.events[eventName] = event;
		}

		event.registerCallback(callback);
	}


	/**
	 * @param {string} eventName
	 * @param {function} callback
	 */
	off(eventName, callback)
	{
		const event = this.events[eventName];

		if (event && (event.callbacks.indexOf(callback) > -1))
		{
			event.unregisterCallback(callback);

			if (event.callbacks.length === 0)
			{
				delete this.events[eventName];
			}
		}
	}
}
